import http from "../../http";

const BASE = "/gateway/api/sycompany/pc/companyGoodsStock";

const goodsStock = {
    resolveStockMode(r) {
        return http.get(`${BASE}/resolveStockMode`, r)
    },
    selectSellablePage(r) {
        return http.get(`${BASE}/selectSellablePage`, r)
    },
    selectStockPage(r) {
        return http.get(`${BASE}/selectStockPage`, r)
    },
    summarizeSku(r) {
        return http.get(`${BASE}/summarizeSku`, r)
    },
    /** 批量库存汇总（按商品ID列表，一次返回各规格） */
    summarizeByGoodsIds(r) {
        return http.payload(`${BASE}/summarizeByGoodsIds`, r)
    },
    stockOverview(r) {
        return http.get(`${BASE}/stockOverview`, r)
    },
    stockWarnList(r) {
        return http.get(`${BASE}/stockWarnList`, r)
    },
    replenishSuggestions(r) {
        return http.get(`${BASE}/replenishSuggestions`, r)
    },
    adjustHq(r) {
        return http.payload(`${BASE}/adjustHq`, r)
    },
    /** 按商品从 o2o 同步总店未分配（新建/补录；可重试） */
    syncHqFromGoods(r) {
        return http.payload(`${BASE}/syncHqFromGoods`, r)
    },
    allocate(r) {
        return http.payload(`${BASE}/allocate`, r)
    },
    confirmAllocate(r) {
        return http.payload(`${BASE}/confirmAllocate`, r)
    },
    rejectAllocate(r) {
        return http.payload(`${BASE}/rejectAllocate`, r)
    },
    selectAllocatePage(r) {
        return http.get(`${BASE}/selectAllocatePage`, r)
    },
    selectAllocateById(r) {
        return http.get(`${BASE}/selectAllocateById`, r)
    },
    updatePointSellable(r) {
        return http.payload(`${BASE}/updatePointSellable`, r)
    },
    removePointStock(r) {
        return http.payload(`${BASE}/removePointStock`, r)
    },
    initHqFromO2o(r) {
        return http.post(`${BASE}/initHqFromO2o`, r)
    },
    updateStockMode(r) {
        return http.post(`${BASE}/updateStockMode`, r)
    },
}
export default goodsStock
